/**
 * Indexer API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
package indexer.codegen

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

/**
 *
 * @param equity
 * @param netTransfers
 * @param totalPnl
 * @param createdAt
 * @param createdAtHeight
 */
@JsExport
@Serializable
data class IndexerPnlResponseObject(

    val equity: kotlin.String? = null,
    val netTransfers: kotlin.String? = null,
    val totalPnl: kotlin.String? = null,
    val createdAt: kotlin.String? = null,
    val createdAtHeight: kotlin.String? = null
)
